export function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <img 
        src="https://public.readdy.ai/ai/img_res/cb36c34a93f6d4bb60cc202bbcbffdb6.jpg"
        alt="Modern iOS Technology Background"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Modern iOS Applications
        </h2>
        <p className="text-3xl lg:text-4xl font-light italic text-white/90 mb-8">
          for Enhanced Security
        </p>
        <p className="text-lg lg:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed">
          We are a team of experts developing modern applications for the iOS platform. Our products, such as <strong>VPN</strong> and <strong>Cleaner</strong>, are designed to enhance user experience and improve the security of mobile devices.
        </p>
      </div>
    </section>
  );
}
